import 'polyfill';
import 'utils/setupErrorLogging';

import URI from 'urijs';
import EventTracking from 'lib/EventTracking';
import _ from 'lodash';

import Config from 'Config';
import Root from './root';
import * as React from 'react';
import ReactDOM from 'react-dom';
import invariant from 'invariant';
import AuthActions from 'auth/AuthActions';
import { createReduxStore } from 'reduxStore';
import { AppContainer } from 'react-hot-loader';
import { getApolloClientSingleton } from 'lib/apollo/client/browser';

// @ts-expect-error
__webpack_public_path__ = Config.Environment.PUBLIC_SHARESDK_PATH; // eslint-disable-line

const redux = createReduxStore();

const currentURL = window.location.href;
const SHARE_SDK_PARTNERNAME = URI(currentURL).search(true)['share_sdk_partner'];
const { referrer } = window.document;

EventTracking.addSessionProperties({
  share_sdk_partner: _.isEmpty(SHARE_SDK_PARTNERNAME) ? null : SHARE_SDK_PARTNERNAME,
  share_sdk_partner_url: _.isEmpty(referrer) ? null : referrer,
});

function render() {
  const container = document.getElementById('app');
  invariant(container, 'renderApp missing app container');

  try {
    ReactDOM.render(
      <AppContainer>
        <Root reduxStore={redux} apolloClient={getApolloClientSingleton()} />
      </AppContainer>,
      container
    );
  } catch (e: any) {
    console.debug(e, e?.stack);
    console.error('fatal app error on render');
    ReactDOM.render(<div>error</div>, container);
  }

  if (module.hot) {
    module.hot.accept('./root.tsx', () => {
      const NextRoot = require('./root.tsx').default;
      ReactDOM.render(
        <AppContainer>
          <NextRoot reduxStore={redux} apolloClient={getApolloClientSingleton()} />
        </AppContainer>,
        container
      );
    });
  }
}

AuthActions.loadAppDataIfWindowUser().then(render, render);
